module.exports = __webpack_public_path__ + "img/top-workload.60369234.png";